import * as React from 'react';
import { Image } from './Image';
import DropDownMenu from './DropDownMenu';

export interface MenuProps {
}

class Menu extends React.Component<MenuProps, any> {
  constructor(props: MenuProps) {
    super(props);

    this.state = { isHidden: true };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    if (!this.state.isHidden) {
      $('#dropdown-menu').unbind('clickoutside');
    }

    this.setState({
      isHidden: !this.state.isHidden
    });
  }

  render() {
    let dropdown = null;
    if (!this.state.isHidden) {
      dropdown = <DropDownMenu toggleMenu={this.toggleMenu} />;
    }

    return (
      <div id='menu-wrapper'>
        <div id='menu-button' onClick={this.toggleMenu}>
          <div className='menu-button-wrapper'>
            <p>Menu</p>
            <Image className='menu-hamburger' source='hamburger.png' alt='menu-hamburger' />
          </div>
        </div>
        {dropdown}
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Menu.tsx